import { useMemo } from 'react';

import { ContentPointBody } from 'approot/activity-builder/components/teaching-notes/key-activity-information/content-points/content-point-body';
import ListSearch from 'approot/shared/list-search/list-search';
import { ContentPoint } from './content-points.constants';

type Props = {
  contentPoints: ContentPoint[];
  selectedContentPointIds: number[];
  placeholder?: string;
  disabled?: boolean;
  onContentPointSelected: (contentPoint: ContentPoint | undefined) => void;
};

const ContentPointsSearch = ({
  contentPoints,
  selectedContentPointIds,
  disabled,
  onContentPointSelected,
}: Props) => {
  const filteredContentPoints = useMemo(() => {
    return contentPoints
      .filter(
        contentPoint => !selectedContentPointIds.includes(contentPoint.id)
      )
      .map(cp => ({
        id: cp.id,
        label: cp.content,
      }));
  }, [contentPoints, selectedContentPointIds]);

  return (
    <ListSearch
      isMulti={false}
      fieldName="contentPointsSearch"
      options={filteredContentPoints}
      placeholder="Search"
      isDisabled={disabled}
      formatMenuOptionLabel={option => (
        <ContentPointBody content={option.label} />
      )}
      onSelect={item =>
        onContentPointSelected(contentPoints.find(cp => cp.id === item.id))
      }
    />
  );
};

export default ContentPointsSearch;
